import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { PRICE } from '../../data/content';
const optionOne = ['Cercare.', 'Confrontare.', 'Dubitare.', 'E cercare di arrivare alla decisione corretta prima che la visita finisca.'];
const optionTwo = ['Identificare la situazione clinica.', 'Seguire il percorso corretto.', 'Dato → Decisione → Azione → Monitoraggio → Invio, con un metodo strutturato.'];
export function FinalChoice() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-20" data-id="element-211" data-mp="2wvwxt1dch1yg">
      <div className="mx-auto max-w-4xl" data-id="element-212" data-mp="2rx2434du9szk">
        <h2 className="text-center font-display text-[24px] font-extrabold leading-[1.18] text-navy-deep sm:text-4xl" data-id="element-213" data-mp="2rxv5dpu13qab">
          La prossima volta che un paziente entra nel tuo studio con una creatinina
          elevata…
        </h2>
        <p className="mt-3 text-center text-[15px] font-semibold text-navy/70 sm:text-lg" data-id="element-214" data-mp="q3md26duac42">
          Avrai due possibilità.
        </p>

        <div className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5" data-id="element-215" data-mp="39xcmx9nsg4wh">
          <div className="flex flex-col rounded-3xl border border-navy-deep/10 bg-cream p-5 sm:p-7" data-id="element-216" data-mp="3dzhg67abqzil">
            <p className="text-[10.5px] font-extrabold uppercase tracking-[0.18em] text-navy/50" data-id="element-217" data-mp="2zzoi1qwgxh0l">
              Opzione 1
            </p>
            <h3 className="mt-2 font-display text-[19px] font-bold leading-snug text-navy-deep sm:text-[22px]" data-id="element-218" data-mp="34zuavaeh59k9">
              Continuare a cercare risposte tra diverse linee guida.
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5" data-id="element-219" data-mp="1h12dc0jzawy">
              {optionOne.map(item => <li key={item} className="flex gap-2.5" data-id="element-220" data-mp="3ixiz8s7r2yu2">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert/70" aria-hidden="true" data-id="element-221" data-mp="3nxndebl6rhh4" />
                  <span className="text-[14px] leading-relaxed text-navy/75" data-id="element-222" data-mp="fg93iaga0t3s">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl border-2 border-kidney bg-navy-deep p-5 sm:p-7" data-id="element-223" data-mp="u37pvr0a0xbn">
            <p className="text-[10.5px] font-extrabold uppercase tracking-[0.18em] text-kidney-bright" data-id="element-224" data-mp="p5z99uus11ci">
              Opzione 2
            </p>
            <h3 className="mt-2 font-display text-[19px] font-bold leading-snug text-white sm:text-[22px]" data-id="element-225" data-mp="g4rmoa1mhoy9">
              Aprire Percorso Malattia Renale™.
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5" data-id="element-226" data-mp="b7rg7y0v2k6m">
              {optionTwo.map(item => <li key={item} className="flex gap-2.5" data-id="element-227" data-mp="6cvaxw6m60bk">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-kidney-bright" aria-hidden="true" data-id="element-228" data-mp="1gwt6rfsjgk4" />
                  <span className="text-[14px] leading-relaxed text-white/80" data-id="element-229" data-mp="3okl20lk7wudq">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-2xl text-center sm:mt-12" data-id="element-230" data-mp="1z3ph2p3toclh">
          <p className="text-[15px] leading-relaxed text-navy/75 sm:text-lg" data-id="element-231" data-mp="1z5s7vbcsu9r9">
            Non hai bisogno di più informazioni. Hai bisogno di un modo migliore per
            utilizzare le informazioni che già possiedi.
          </p>
          <p className="mt-2 font-display text-[24px] font-extrabold text-kidney-dark sm:text-3xl" data-id="element-232" data-mp="2d3qiq6rwvo20">
            Hai bisogno di un percorso.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-233" data-mp="1gb4vlsqgd9rp">
          <CtaButton label="Sì — voglio Percorso Malattia Renale™" sub={`Ottieni il sistema completo per ${PRICE} • Download immediato • Pagamento unico • Accesso a vita • Garanzia di 7 giorni`} data-id="element-234" data-mp="1kfkxliwy3x1n" />
        </div>
      </div>
    </section>;
}